import { CIL_POINTS_LABEL } from '../utils/cilPoints';

export const CIL_POINTS_GUIDE_PATH = '/cil-points';

export const drawerMeta = {
  title: `Cosa sono i ${CIL_POINTS_LABEL}?`,
  subtitle:
    'Un modo per valorizzare la partecipazione alla community CIL, non un sistema di guadagno.',
};

export const drawerSections = [
  {
    title: `Cosa sono i ${CIL_POINTS_LABEL}`,
    body: `Sono punti virtuali legati al tuo account CIL. Non sono euro, non si vendono e non si scambiano con denaro: servono solo all'interno delle iniziative dell'associazione.`,
  },
  {
    title: 'Perché esistono',
    body: `CIL è un'associazione di promozione sociale. I ${CIL_POINTS_LABEL} riconoscono chi partecipa agli eventi e sostiene la community — gioco, cultura e incontro — senza finalità di lucro.`,
  },
  {
    title: 'Come si ottengono',
    body: `Oggi principalmente partecipando a tornei ed eventi CIL selezionati. L'assegnazione avviene secondo le regole comunicate per ogni iniziativa; non è automatica su ogni iscrizione.`,
    bullets: [
      "Controlla le info dell'evento o chiedi allo staff in sede",
      "Il saldo si vede nell'area personale dopo l'accredito",
    ],
  },
  {
    title: 'Come si usano',
    body: 'Puoi spenderli in due modi, quando disponibili:',
    bullets: [
      'Catalogo premi: prenoti un premio e lo ritiri in sede',
      'Alcuni eventi: pagamento della prenotazione con punti, se previsto',
    ],
  },
];

export const disclaimer = {
  title: 'Nota per la community',
  body: `I ${CIL_POINTS_LABEL} sono gestiti da CIL – Creatività in Libertà APS per favorire partecipazione e spirito associativo. Non costituiscono moneta, investimento o strumento commerciale. Regole, quantità e disponibilità premi possono variare per ogni iniziativa.`,
};

export const pageHero = {
  badge: 'Community CIL',
  title: `${CIL_POINTS_LABEL}: partecipa, accumula, sostieni la community`,
  subtitle: `Scopri come funzionano i punti dell'associazione, come ottenerli partecipando agli eventi e come usarli per premi ed iniziative.`,
};

export const pageSections = [
  {
    id: 'cosa-sono',
    badge: '01',
    title: `Cosa sono i ${CIL_POINTS_LABEL}`,
    paragraphs: [
      `I ${CIL_POINTS_LABEL} sono un saldo virtuale sul tuo account, dedicato alle attività CIL. Non hanno valore monetario legale e non possono essere convertiti in euro.`,
      "Ogni movimento (assegnazione o spesa) è tracciato dall'associazione per garantire trasparenza verso i soci e i partecipanti.",
    ],
  },
  {
    id: 'perche',
    badge: '02',
    title: 'Perché li usiamo',
    paragraphs: [
      'CIL promuove creatività, gioco e inclusione in uno spazio condiviso. I punti aiutano a rendere visibile il contributo di chi partecipa, si impegna e fa crescere la community.',
      'Non è un programma fedeltà commerciale: è uno strumento associativo per incentivare presenza, fair play e collaborazione.',
    ],
  },
  {
    id: 'ottenere',
    badge: '03',
    title: 'Come si ottengono',
    paragraphs: [
      'Al momento i punti vengono assegnati soprattutto in occasione di tornei ed eventi selezionati organizzati da CIL.',
      "Per ogni iniziativa valgono le regole indicate dall'organizzazione (ad esempio classifica, partecipazione, fair play). L'accredito sul tuo account avviene dopo la verifica da parte dello staff — non è istantaneo su ogni prenotazione.",
    ],
    bullets: [
      "Consulta il calendario eventi e le comunicazioni dell'iniziativa",
      "Partecipa agli eventi che prevedono l'assegnazione di punti",
      'Controlla il saldo nella tua area personale',
    ],
  },
  {
    id: 'riscattare',
    badge: '04',
    title: 'Come si riscattano i premi',
    paragraphs: [
      'Nel catalogo premi trovi gli articoli disponibili, il costo in punti e la quantità in stock. Scegli il premio, confermi il riscatto dal tuo account e i punti vengono scalati.',
      "Il premio va ritirato in sede: riceverai conferma e lo stato del ritiro nell'area «I tuoi premi».",
    ],
    bullets: [
      'Accedi al catalogo con il tuo account',
      'Verifica di avere punti sufficienti',
      'Prenota e passa in sede per il ritiro',
    ],
    cta: {
      label: 'Catalogo premi',
      to: '/catalogo-premi',
    },
  },
  {
    id: 'eventi',
    badge: '05',
    title: 'Uso sugli eventi',
    paragraphs: [
      "Alcuni eventi permettono di pagare la prenotazione (totale o parziale) con i CIL Points, se l'opzione è attiva nella scheda evento.",
      'In quel caso i punti vengono scalati come per un ordine interno; non sostituiscono donazioni o quote associative in euro.',
    ],
  },
];

export const pageFaq = [
  {
    q: 'I punti scadono?',
    a: 'Le regole possono variare per iniziativa. In generale il saldo resta sul tuo account finché non lo usi; per dubbi specifici chiedi allo staff CIL.',
  },
  {
    q: 'Posso convertirli in euro?',
    a: 'No. I CIL Points non sono denaro e non sono rimborsabili in contanti.',
  },
  {
    q: 'Dove vedo il mio saldo?',
    a: "Dopo l'accesso, nella sezione Account → Informazioni trovi il saldo aggiornato.",
  },
];

export const pageCtas = [
  {
    label: 'Catalogo premi',
    to: '/catalogo-premi',
    primary: true,
  },
  {
    label: 'Area personale',
    to: '/account/informazioni',
    primary: false,
  },
  {
    label: 'Calendario eventi',
    to: '/attivita',
    primary: false,
  },
  {
    label: 'Tornei Magic',
    to: '/magic-tcg',
    primary: false,
  },
];
